import React from "react";
import { motion } from "framer-motion";
import { IoClose } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom"; // Import useNavigate
import FlatListingHeader from "./FlatListingHeader/FlatListingHeader";
import ImageSlider from "./ImageSlider/ImageSlider";
import useCustomNavigate from "../../../../hooks/useCustomNavigate";

const AllImagesPage = () => {

  const {goTo} = useCustomNavigate()

  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-90 flex justify-center  px-2 py-4 z-50"
    >
      <div className="relative w-full  bg-black p-4 rounded-lg max-h-[95vh] overflow-y-auto shadow-lg">
        {/* Close Button */}
        {/* <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-white bg-gray-800 p-2 rounded-full"
        >
          <IoClose size={24} />
        </button> */}

        {/* Content */}
        <FlatListingHeader />
        <ImageSlider />
      </div>
    </motion.div>
  );
};

export default AllImagesPage;
